import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import SectionsHeading from "../../SectionsHeading";
import {
  AbsoluteImage,
  FlexDiv,
  GradiantDiv,
  OuterGradiantDiv,
  SecondGradiantDiv,
} from "../../../Styles/style";
import Paragraph from "../../Paragraph";
import CustomButton from "../../CustomBtn";

const GridWraper = styled(Grid)`
  width: 100%;
  height: 100%;
  display: flex;
  /* flex-direction:column; */
  justify-content: center;
  align-items: center;
  padding: 100px 0;
`;
const ContinerWraper = styled(Container)`
  background: #050C24;
  height: auto;
  width: 100%;
  padding: 0 !important;
`;

const AboutSection = () => {
  return (
    <ContinerWraper maxWidth="xxl" id="about">
      <Container>
        <GridWraper container>
          <Grid item xs={12}>
            <SectionsHeading ta="center" data-aos="zoom-in">About</SectionsHeading>
          </Grid>
          <Grid item xs={10} md={8}>
            <OuterGradiantDiv>
              <SecondGradiantDiv>
                <GradiantDiv p599="30px">
                  <Paragraph ta="center" fs599="12px" data-aos="fade-up">
                    Moonracer isn't just a crypto project; we're a
                    community-driven revolution in decentralized finance. Our
                    foundation is built on transparency, security, and
                    empowerment. By leveraging smart contracts and ERC-20
                    tokens, we've pioneered a system using transaction taxes to
                    accumulate ETH tokens.
                  </Paragraph>
                  <Paragraph ta="center" fs599="12px" data-aos="fade-up">
                    After a one hour waiting period, the last 10 buyers of
                    Moonracer tokens receive accumulated ETH tokens. 4/4 of
                    transaction taxes are collected, allocating 1/1 to the dev
                    wallet and 3/3 to the reward pool. Within the reward pool,
                    when the waiting period ends, 50% is reserved for future
                    use, 40% is airdropped to buyers, and 10% is used for token
                    buybacks. This sustainable approach ensures a continuous
                    reward cycle and growth.
                  </Paragraph>
                  <FlexDiv jc="center" data-aos="fade-up">
                    <CustomButton sx={{ width: "150px" }} fs599="9px">
                      Buy Now
                    </CustomButton>
                    <CustomButton
                      sx={{ width: "150px" }}
                      fs599="9px"
                      bgc="transparent"
                      b="1px solid #fff"
                      bs="none"
                    >
                      View Chart
                    </CustomButton>
                  </FlexDiv>
                  <AbsoluteImage
                    t599="-3%"
                    l599="92%"
                    w599="40px"
                    t="-10%"
                    l="95%"
                    src="./Images/moon.png"
                  />
                  <AbsoluteImage
                    t599="90%"
                    l599="-13%"
                    w="120px"
                    w599="80px"
                    t="80%"
                    l="-6%"
                    src="./Images/rocket.png"
                  />
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </Grid>
        </GridWraper>
      </Container>
    </ContinerWraper>
  );
};

export default AboutSection;
